import axios from '../requester';
import { API } from '../constants/api-urls';
import { INVITATION_TYPE } from '@linearb/linjs-common';

export const getEmailInvitationParams = isAdmin => ({
  params: { invitation_type: INVITATION_TYPE.EMAIL, invite_admin: isAdmin }
});

export const accountInvitation = async data =>
  axios.post(API.INVITATIONS_PATH, data, getEmailInvitationParams(false));
export const accountAdminInvitation = async data =>
  axios.post(API.INVITATIONS_PATH, data, getEmailInvitationParams(true));
export const getInvitations = async params =>
  axios.get(API.INVITATIONS_PATH, { params });
export const getInvitation = async id =>
  axios.get(`${API.INVITATIONS_PATH}/${id}`);
export const deleteInvitation = async id =>
  axios.delete(`${API.INVITATIONS_PATH}/${id}`);
export const resendInvitation = async id =>
  axios.post(
    `${API.INVITATIONS_PATH}/${id}/reinvite`,
    null,
    getEmailInvitationParams
  );

export const changeInvitationAccountType = async (id, typeId) =>
  axios.patch(`${API.INVITATIONS_PATH}/change-account-type/${id}`, {
    type_id: typeId
  });

export const accountInvitationNew = async (data, isAdmin) =>
  axios.post(API.INVITATIONS_PATH, data, getEmailInvitationParams(isAdmin));

  export const updateInvitationPermission = async (id, data) =>
    axios.patch(`${API.INVITATIONS_PATH}/${id}/permission`, data);
   